<pcg-control-group class="col-md-6" label="Module Name">
    <input class="col-md-6 input" type="text" [(ngModel)]="newModuleName" (click)="resetValidation()" />
</pcg-control-group>
<button class="btn btn-save btn-lg small-margin" (click)="addNewModuleName(newModuleName)">Add</button>
@if (isError) {
    <div class="red-message">{{ errorMessage }}</div>
}
